import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessagesImage.vue?vue&type=template&id=19af6b44"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessagesImage.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessagesImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__